import moment from "moment";
import "moment/locale/es";
import { cuentaMask, dineroDisabledMask } from '../Components/Items'
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";

moment.locale("es");

const reporteDeNotasDeCreditoCompraPdf = (values) => {
    const empresa = values.empresa
    const logoBiwo = values.logoBiwo;
    let filtrados = []
    if (values.proveedores !== 0 && values.proveedores && values.proveedores.length > 0) {
        let textoFiltrado = ''
        values.proveedores.map((valueProveedor) => {
            textoFiltrado += `${(valueProveedor.persona ? valueProveedor.nombre : (valueProveedor.nombre + ' ' + valueProveedor.apellidoPaterno + ' ' + valueProveedor.apellidoMaterno)) + valueProveedor.razonSocial + " - " + valueProveedor.rfc}\n`
            return null
        })
        filtrados.push([
            { text: 'Proveedores:', style: 'subheader' },
            { text: textoFiltrado, style: 'textoChico' }
        ])
    }

    if (values.filtrarProyecto === 1) {
        let textoFiltrado = ''
        values.proyectos.map((valueProyectos) => {
            textoFiltrado += `${valueProyectos.nombre}\n`
            return null
        })
        filtrados.push([
            { text: 'Proyectos:', style: 'subheader' },
            { text: textoFiltrado, style: 'textoChico' }
        ])
    }

    if (values.filtrarProyecto === 2) {
        filtrados.push([
            { text: 'Unidad de Negocio:', style: 'subheader' },
            {
                text: `${cuentaMask(
                    values.unidadDeNegocio.nivel1 + values.unidadDeNegocio.nivel2 + values.unidadDeNegocio.nivel3 + values.unidadDeNegocio.nivel4 + values.unidadDeNegocio.nivel5
                ) +
                    " - " +
                    values.unidadDeNegocio.nombre}`, style: 'textoChico'
            }
        ])
    }

    const tablasDinamicas = [];

    const porMoneda = {};
    values.notas.forEach((nota) => {
        const monedaKey = nota.moneda || "Sin Moneda";
        if (!porMoneda[monedaKey]) porMoneda[monedaKey] = [];
        porMoneda[monedaKey].push(nota);
    });

    Object.keys(porMoneda).forEach((moneda) => {
        const notasMoneda = porMoneda[moneda];

        let totalACobrar = 0;
        let totalPagado = 0;
        let totalSaldo = 0;
        let totalSubtotal = 0;
        let totalImpuestos = 0;
        let totalRetenciones = 0;

        const filasNotas = notasMoneda.map((valueNota) => {
            const properties = valueNota.colorStyle ? { background: valueNota.colorStyle } : {};

            totalACobrar += parseFloat(valueNota.totalPagar || 0);
            totalPagado += parseFloat(valueNota.totalPagado || 0);
            totalSaldo += parseFloat(valueNota.saldo || 0);
            totalSubtotal += parseFloat(valueNota.subtotal || 0);
            totalImpuestos += parseFloat(valueNota.totalImpuestos || 0);
            totalRetenciones += parseFloat(valueNota.totalRetenciones || 0);

            return [
                { text: valueNota.folio, style: 'textoTabla', alignment: 'left' },
                { text: isNaN(valueNota.fechaFactura) ? moment(valueNota.fechaFactura, "DD/MM/YYYY").locale('es').format('L') : valueNota.fechaFactura, style: 'textoTabla', alignment: 'center' },
                { text: valueNota.folioOrigen || '', style: 'textoTabla', alignment: 'left' },
                { text: valueNota.proveedor, style: 'textoTabla', alignment: 'left' },
                { text: dineroDisabledMask(valueNota.totalPagar), style: 'textoTabla', alignment: 'right' },
                { text: dineroDisabledMask(valueNota.totalPagado), style: 'textoTabla', alignment: 'right' },
                { text: dineroDisabledMask(valueNota.saldo), style: 'textoTabla', alignment: 'right' },
                { text: valueNota.estado, ...properties, style: 'textoTabla', alignment: 'left' },
            ];
        });

        filasNotas.push([
            { text: `TOTAL (${moneda}):`, style: 'totalChico', alignment: 'left', border: [true, true, true, true], fillColor: '#cccccc' },
            { text: '', style: 'totalChico', border: [false, true, false, true], fillColor: '#cccccc' },
            { text: '', style: 'totalChico', border: [false, true, false, true], fillColor: '#cccccc' },
            { text: '', style: 'totalChico', border: [false, true, false, true], fillColor: '#cccccc' },
            { text: dineroDisabledMask(totalACobrar), style: 'totalChico', alignment: 'right', border: [true, true, true, true], fillColor: '#cccccc' },
            { text: dineroDisabledMask(totalPagado), style: 'totalChico', alignment: 'right', border: [true, true, true, true], fillColor: '#cccccc' },
            { text: dineroDisabledMask(totalSaldo), style: 'totalChico', alignment: 'right', border: [true, true, true, true], fillColor: '#cccccc' },
            { text: '', style: 'totalChico', border: [false, true, true, true], fillColor: '#cccccc' },
        ]);

        tablasDinamicas.push(
            { text: `Moneda: ${moneda}`, style: "subheader", margin: [0, 5, 0, 2] },
            {
                style: 'tableExample',
                table: {
                    widths: ['8%', '11%', '14%', '24%', '11%', '11%', '11%', '10%'],
                    headerRows: 1,
                    body: [
                        [
                            { text: 'Folio', style: 'tituloTabla' },
                            { text: 'Fecha', style: 'tituloTabla' },
                            { text: 'Factura Origen', style: 'tituloTabla' },
                            { text: 'Proveedor', style: 'tituloTabla' },
                            { text: 'Total', style: 'tituloTabla' },
                            { text: 'Aplicado', style: 'tituloTabla' },
                            { text: 'Saldo', style: 'tituloTabla' },
                            { text: 'Estado', style: 'tituloTabla' },
                        ],
                        ...filasNotas
                    ]
                },
                layout: {
                    fillColor: (rowIndex) => rowIndex % 2 === 0 && rowIndex !== 0 ? "#e8e8e8" : "#ffffff",
                    hLineWidth: (i, node) => (i === 0 || i === node.table.body.length) ? 1 : 1,
                    vLineWidth: (i, node) => (i === 0 || i === node.table.widths.length) ? 1 : 1,
                    hLineColor: () => '#adaaaa',
                    vLineColor: () => '#adaaaa',
                    hLineStyle: (i, node) => (i === 0 || i === node.table.body.length) ? null : { dash: { length: 2, space: 1 } },
                    vLineStyle: (i, node) => (i === 0 || i === node.table.widths.length) ? null : { dash: { length: 2 } },
                }
            },
            {
                margin: [0, 2, 0, 8],
                table: {
                    widths: ['19%', '3%', '19%', '3%', '19%', '3%', '19%', '3%', '12%'],
                    body: [
                        [
                            { text: 'Subtotal', style: 'tituloTabla', alignment: 'center' },
                            { text: '+', style: 'textoTabla', alignment: 'center', border: [false, false, false, false] },
                            { text: 'Impuestos', style: 'tituloTabla', alignment: 'center' },
                            { text: '=', style: 'textoTabla', alignment: 'center', border: [false, false, false, false] },
                            { text: 'Total', style: 'tituloTabla', alignment: 'center' },
                            { text: '-', style: 'textoTabla', alignment: 'center', border: [false, false, false, false] },
                            { text: 'Retenciones', style: 'tituloTabla', alignment: 'center' },
                            { text: '=', style: 'textoTabla', alignment: 'center', border: [false, false, false, false] },
                            { text: 'Total a Devolver', style: 'tituloTabla', alignment: 'center' },
                        ],
                        [
                            { text: dineroDisabledMask(totalSubtotal), style: 'totalChico', alignment: 'right', fillColor: '#e8e8e8' },
                            { text: '', border: [false, false, false, false] },
                            { text: dineroDisabledMask(totalImpuestos), style: 'totalChico', alignment: 'right', fillColor: '#e8e8e8' },
                            { text: '', border: [false, false, false, false] },
                            { text: dineroDisabledMask(totalSubtotal + totalImpuestos), style: 'totalChico', alignment: 'right', fillColor: '#e8e8e8' },
                            { text: '', border: [false, false, false, false] },
                            { text: dineroDisabledMask(totalRetenciones), style: 'totalChico', alignment: 'right', fillColor: '#e8e8e8' },
                            { text: '', border: [false, false, false, false] },
                            { text: dineroDisabledMask(totalACobrar), style: 'totalChico', alignment: 'right', fillColor: '#cccccc' },
                        ],
                    ]
                },
                layout: {
                    hLineWidth: () => 1,
                    vLineWidth: (i, node) => (i === 0 || i === node.table.widths.length) ? 1 : 0,
                    hLineColor: () => '#adaaaa',
                    vLineColor: () => '#adaaaa',
                }
            }
        );
    });

    if (filtrados.length === 0) {
        filtrados.push([
            { text: 'No tiene filtrados adicionales', style: 'subheader' },
            { text: '', style: 'textoChico' }
        ])
    }

    var dd = {
        footer: {
            image: 'logoBiwo', alignment: 'center', width: 80
        },
        content: [
            {
                style: 'tableExample',
                table: {
                    widths: ['18%', '52%', '30%'],
                    layout: {
                        defaultBorder: false,
                    },
                    body: [
                        [
                            ...HeaderEmpresaCard(empresa, false, false,
                                {
                                    border: [false, false, false, false],
                                    table: {
                                        headerRows: 1,
                                        widths: ['100%'],
                                        body: [
                                            [{ text: 'Fecha Inicial:', style: 'subheader', alignment: 'center' }],
                                            [{ text: moment(values.fechaInicial).locale('es').format('LL'), style: 'textoChico', alignment: 'center' }],
                                            [{ text: 'Fecha Final:', style: 'subheader', alignment: 'center' }],
                                            [{ text: moment(values.fechaFinal).locale('es').format('LL'), style: 'textoChico', alignment: 'center' }],
                                            [{ text: 'Fecha de Impresión:', style: 'subheader', alignment: 'center' }],
                                            [{ text: moment().locale('es').format('LL'), style: 'textoChico', alignment: 'center' }],
                                        ]
                                    },
                                    layout: 'noBorders'
                                }),
                        ]
                    ]
                },
            },
            {
                text: "Reporte de Notas de Credito de Compra",
                style: "tableHeaderIzquierda",
            },
            { text: 'Datos de filtrado:' },
            {
                style: 'tableExample',
                table: {
                    widths: ['20%', '80%'],
                    layout: {
                        defaultBorder: false,
                    },
                    body: filtrados,
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function () { return '#adaaaa'; },
                    vLineColor: function () { return '#adaaaa'; },
                    hLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.body.length) return null;
                        return { dash: { length: 2, space: 1 } };
                    },
                    vLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.widths.length) return null;
                        return { dash: { length: 2 } };
                    },
                }
            },
            ...tablasDinamicas,
        ],
        images: {
            logo: empresa.logo.base64Completa,
            logoBiwo: logoBiwo.base64Completa,
        },
        styles: {
            tableHeaderIzquierda: { bold: true, fontSize: 18, color: "black" },
            header: { fontSize: 9, bold: true },
            subheader: { fontSize: 8, bold: true },
            tableExample: { margin: [0, 5, 0, 5] },
            tablaSinMargen: { margin: [0, 0, 0, 0] },
            tableHeader: { bold: true, fontSize: 12, color: 'black', alignment: 'center' },
            textoChico: { fontSize: 8 },
            tituloTabla: {
                fontSize: 8, bold: true, fillColor: '#cccccc', style: 'subheader', alignment: 'center', border: true
            },
            textoTabla: { fontSize: 8, italics: false },
            totalChico: { fontSize: 6, bold: true, fillColor: '#cccccc', alignment: 'right', border: true }
        },
        pageSize: 'LETTER',
        pageOrientation: 'landscape',
        pageMargins: [20, 20, 20, 60],
    }
    return dd;
};

export default reporteDeNotasDeCreditoCompraPdf;
